import {
  ChangeChannelRequest,
  ChannelEndpoint,
  DeliveryStatus,
  QuotationExchangeChannel,
} from 'services/APIs/InternalAPI/internal-api.contracts'

export const selectableChannels = [
  QuotationExchangeChannel.Scsn,
  QuotationExchangeChannel.Email,
  QuotationExchangeChannel.Manual,
] as const

export const emailIsValid = (email?: string) =>
  Boolean(email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))

export const readableLabel = (value?: string) =>
  value ? value.replace(/([a-z])([A-Z])/g, '$1 $2') : 'Not set'

export function createChannelRequest(
  channel: QuotationExchangeChannel,
  sender?: ChannelEndpoint,
  recipient?: ChannelEndpoint,
): ChangeChannelRequest {
  if (channel === QuotationExchangeChannel.Email) {
    if (!emailIsValid(recipient?.address)) {
      throw new Error('Select a valid supplier Email recipient.')
    }
    return {
      channel,
      sender: {
        channel,
        address: 'rfq@quotationfactory.com',
        displayName: 'QuotationFactory RFQ',
      },
      recipient,
    }
  }
  if (channel === QuotationExchangeChannel.Scsn) {
    return { channel }
  }

  return {
    channel,
    sender: {
      channel,
      address: undefined,
    },
    recipient: {
      channel,
      address: undefined,
    },
  }
}

export const canSend = (status?: DeliveryStatus) =>
  status === DeliveryStatus.NotStarted || canRetry(status)

export const canRetry = (status?: DeliveryStatus) =>
  status === DeliveryStatus.Failed ||
  status === DeliveryStatus.Sent ||
  status === DeliveryStatus.Delivered

export function errorMessage(error: unknown) {
  const appError = error as {
    status?: number
    message?: string
    validation?: Record<string, string | string[]>
  }
  if (appError.status === 401) return 'Your session has expired. Sign in again.'
  if (appError.status === 403)
    return 'You do not have contributor permission for this action.'
  const validation = appError.validation
    ? Object.values(appError.validation).flat().join(' ')
    : ''
  return validation || appError.message || 'The request could not be completed.'
}
